module.exports = __webpack_public_path__ + "static/media/fb.4cff77c3.svg";